import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from "react-dom"
import App from "./App";
import './locales';

declare let window: any;

const startApp = () => {
    ReactDOM.render(
        <App/>,
        document.getElementById("root")
    );
}

const startCordovaApp = () => {
    console.log('START APP LAUNCH FUNCTION')

    // const firebasePlugin = window.FirebasePlugin;
    //
    // firebasePlugin.hasPermission((hasPermission) => {
    //     if (hasPermission) {
    //         firebasePlugin.getToken(function(fcmToken) {
    //             console.log('GOT TOKEN')
    //             alert(fcmToken);
    //         }, function(error) {
    //             console.log('GETTING TOKEN ERROR')
    //             console.error(error);
    //         });
    //     } else {
    //         firebasePlugin.grantPermission((grantSucceed) => {
    //             if (grantSucceed) {
    //                 firebasePlugin.getToken(function(fcmToken) {
    //                     console.log('GOT TOKEN')
    //                     alert(fcmToken);
    //                 }, function(error) {
    //                     console.log('GETTING TOKEN ERROR')
    //                     console.error(error);
    //                 });
    //             } else {
    //                 alert('Error granting permission')
    //             }
    //         })
    //     }
    // })
    //
    // firebasePlugin.onMessageReceived(function(message) {
    //     try{
    //         console.log("ON MESSAGE RECEIVED GOT MESSAGE");
    //         alert(JSON.stringify(message));
    //     }catch(e){
    //         console.log(e)
    //     }
    //
    // }, function(error) {
    //     console.log('ON MESSAGE RECEIVED ERROR HANDLER')
    //     console.log(error)
    // });

    startApp();
}

if (process.env.REACT_APP_BUILD_MODE === 'CORDOVA') {
    console.log('REACT APP BUILD CORDOVA')
    if (window.cordova) {
        console.log('CORDOVA IS HERE')
        document.addEventListener('deviceready', () => {
            alert('deviceready');
            startCordovaApp();
        }, false);
    } else {
        console.log("Something wen wrong, but window is not cordova")
        startApp();
    }
} else {
    console.log('BUILD MODE IS NOT CORDOVA SO JUST START WEB')
    startApp();
}
